"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("../datapoints");
var reportMessageToSafetyLibraryService_1 = require("owa-mail-triage-action/lib/services/reportMessageToSafetyLibraryService");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * The action which marks items as phishing.
 * @param itemIds - the itemIds to mark as phishing * @param actionSource - where this mark as phishing action is triggered
 * @param markAsPhishingStoreUpdate the callback function to update the store upon markItemsAsPhishingDatapoint as phishing
 * @returns a promise to end the markItemsAsPhishingDatapoint datapoint
 */
exports.default = legacy_1.action('markItemsAsPhishing', datapoints_1.default.markItemsAsPhishingDatapoint)(function markItemsAsPhishingBasedOnItemIds(itemIds, actionSource, markAsPhishingStoreUpdate) {
    try {
        reportMessageToSafetyLibraryService_1.default(itemIds, 3 /* Phish */);
    }
    catch (error) {
        // VSO 19006: Handle service error caused by block
    }
    markAsPhishingStoreUpdate();
    // Synchronously returns the promise to end the markItemsAsPhishingDatapoint datapoint
    return Promise.resolve();
});
//# sourceMappingURL=markItemsAsPhishingBasedOnItemIds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/markItemsAsPhishingBasedOnItemIds.js
// module id = 3470
// module chunks = 62